/** Tuning for the custom animation that replaces avaturn_animation in multi-character scenes. */
const avaturnCustomAnimationConfig = {
  /** Breaths per minute, before each avatar's own jitter is applied. */
  breathRate: 15,
  /**
   * How far one avatar's breath rate may stray from that base, as a fraction.
   * Without it a row of avatars inhales in perfect unison, which reads as
   * mechanical; differing rates let them drift apart on their own instead of
   * holding one fixed offset forever.
   */
  breathRateJitter: 0.2,
  /** Total chest pitch at full inhale, in degrees. */
  breathDepth: 1.6,
  /** Shoulder lift at full inhale, in degrees. */
  shoulderLift: 1.2,
  /**
   * How the breath is split down the chain. Spine bends back on inhale and the
   * neck counters it, so the head stays level instead of nodding.
   */
  breathWeight: {
    Spine1: -0.4,
    Spine2: -0.6,
    Neck: 0.7
  },
  blink: {
    /** Random gap between blinks, in seconds. */
    interval: [2.5, 6],
    /** How far the lids close. The original clip peaks at ~0.86. */
    strength: 0.9,
    /** Chance a blink is followed by a second one. */
    doubleChance: 0.15,
    /** Gap to the second blink of a double, in seconds. */
    doubleDelay: 0.3
  },
  gaze: {
    /** Largest gaze offset. The clip's unwanted look to the right reached 0.56. */
    range: { x: 0.12, y: 0.08 },
    /** Resting upward bias, so the eyes do not sit dead centre. */
    restY: 0.06,
    /** Random gap between saccades, in seconds. */
    interval: [0.8, 3.5],
    /** Chance a saccade settles back to the resting point instead of somewhere new. */
    recentreChance: 0.35,
    /** Damping rate for the eyes easing onto a new target. */
    damping: 25
  },
  restingFace: {
    /** Medians sampled from avaturn_animation, blink frames excluded. */
    browDown: 0.17,
    eyeSquint: 0.21,
    /** How far the slow brow drift moves browDown either way. */
    browDrift: 0.05,
    /** Extra squint at full blink, so the lids read as closing rather than sliding. */
    squintOnBlink: 0.1
  },
  /** Longest frame step the custom animation integrates, in seconds. Guards against a backgrounded tab. */
  maxDelta: 0.1
};

export default avaturnCustomAnimationConfig;
